module.exports = __webpack_public_path__ + "static/media/client-5.636ad07e.jpg";